/**
 *
 * Spinner
 *
 */
import StyleComponentProps from 'core/utils/types/StyleComponentProps';
import React, { memo } from 'react';
import styled from 'styled-components/macro';
import loader from 'assets/images/loader.webp';

interface Props extends StyleComponentProps {}

export const Spinner = memo((props: Props) => {
  return (
    <Div
      className="w-full h-full flex justify-center items-center"
      width={props.width}
    >
      <img src={loader} alt="loader" className={`rounded-lg h-[16vh]`} />
      {/* <div className="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div> */}
    </Div>
  );
});

const Div = styled.div<Props>`
  .lds-ring {
    display: inline-block;
    position: relative;
    width: ${props => (props.width ? props.width : '100px')};
    height: ${props => (props.width ? props.width : '100px')};
  }
  .lds-ring div {
    box-sizing: border-box;
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    margin: 8px;
    border: 8px solid #5e4de0;
    border-radius: 50%;
    animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: #5e4de0 transparent transparent transparent;
  }
  .lds-ring div:nth-child(1) {
    animation-delay: -0.45s;
  }
  .lds-ring div:nth-child(2) {
    animation-delay: -0.3s;
  }
  .lds-ring div:nth-child(3) {
    animation-delay: -0.15s;
  }
  @keyframes lds-ring {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
